export const canAccessPage = (loginTime,time) => new Date().getTime() - new Date(loginTime).getTime() < time;
